module.exports = __webpack_public_path__ + "static/media/dice-five.2fc840f0.svg";